import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MatSnackBar } from '@angular/material/snack-bar';

import { Router } from "@angular/router";
import { environment } from "@env/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class KantarService {
  constructor(
    private httpService: HttpClient,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  public sendMailKantar() {
    const url = environment.api_base_url + "/tv/send-kantar-data-file-mail";
    return Observable.create((observer) => {
      this.httpService.get(url).subscribe(
        (response) => observer.next(response),
        (error) => observer.error(this.catchError(error))
      );
    });
  }

  public sendMailNoDataKantar() {
    const url =
      environment.api_base_url + "/tv/alert-kantar-no-data?server=kantar";

    return Observable.create((observer) => {
      this.httpService.get(url).subscribe(
        (response) => observer.next(response),
        (error) => observer.error(this.catchError(error))
      );
    });
  }

  public sendMailKantarFilesExist() {
    const url =
      environment.api_base_url + "/tv/alert-kantar-files-exist?server=kantar";

    return Observable.create((observer) => {
      this.httpService.get(url).subscribe(
        (response) => observer.next(response),
        (error) => observer.error(this.catchError(error))
      );
    });
  }

  public uploadToKantar(date: string = null) {
    let url = environment.api_base_url + "/tv/upload-to-kantar";

    if (date) {
      const [year, month, day] = date.split("-");
      
      date = `${year}${month}${day}`; 
      url += `?date=${date}`;
    }

    return Observable.create((observer) => {
      this.httpService.get(url).subscribe(
        (response) => observer.next(response),
        (error) => observer.error(this.catchError(error))
      );
    });
  }

  private catchError(error: any, routeRedirect: string = null): void {
    switch (error.status) {
      case 504:
        this.snackBar.open(
          "Envoi du mail en cours. Veuillez patienter.",
          null,
          { duration: 2000, verticalPosition: "top" }
        );
        break;
      default:
        this.snackBar.open("Une erreur est survenue", null, {
          duration: 2000,
          verticalPosition: "top",
        });
        break;
    }
    if (routeRedirect) {
      this.router.navigate([routeRedirect]);
    }

    return error;
  }
}
